module.exports = __webpack_public_path__ + "img/TurningStool5.d21d8e23.jpg";